import { IAppointment, IClinic, IProvider } from "interfaces";
import { Apis, Constants, Enums, Helpers, Store } from "utils";

export interface IDiagnosisService {
  all(): Promise<any>;
}

export class DiagnosisService implements IDiagnosisService {
  private qubehub: any;
  private controllerName: string = "diagnosis";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  async all() {
    try {
      const [status, response] = this.#handleResponse(await this.qubehub.get(this.controllerName));
      return response ?? [];
    } catch (err: any) {
      console.log(err);
    }
    return [];
  }

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}
